
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import { Articulo } from '@/__env/lib/Articulos';
    import item from './cantidad-lista-mini-item.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            item,

        }
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorInterfaz;
        @Prop() public Articulo: Articulo;
        @Prop() public Items: Articulo[];
        @Prop() public Seleccionado: number;
        @Prop() public Busqueda: string;
        @Prop() public Estado: string;
        @Prop() public Abrir: boolean;
        @Watch( 'Abrir' )
        onAbrir()
        {
            this.Abierto = this.Abrir;

        }
        public Abierto: boolean = false;
        @Watch( 'Abierto' )
        onAbierto()
        {
            this.$emit( 'abierto', this.Abierto );
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }

        mounted()
        {


        }

    }
